import { useState, useEffect, useCallback } from "react";
import CardList from "../../components/card-list/CardList";
import Search from "../../components/search/Search";
import { getAllRecipes } from "../../helpers/Request";
import useTitle from "../../hooks/useTitle";
import { APP_NAME } from "../../constants/app-name";

export function Home() {
  const [recipes, setRecipes] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchRecipes = useCallback((s) => {
    if (s !== "" && s.length < 3) {
      return;
    }

    setLoading(true);
    getAllRecipes(s)
      .then((data) => {
        setRecipes(data.recipes);
      })
      .catch((_) => {
        alert("Ocurrió un error al cargar las recetas.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useTitle("Inicio");

  useEffect(() => {
    let signal = false;
    if (!signal) {
      fetchRecipes(search);
    }
    return () => (signal = true);
  }, [fetchRecipes, search]);

  let inputTimeout = null;
  const debounceInput = (input) => {
    clearTimeout(inputTimeout);
    inputTimeout = setTimeout(() => {
      setSearch(input);
    }, 250);
  };

  return (
    <>
      <Search onSearch={debounceInput} init={search} />
      <CardList recipes={recipes} search={search} loading={loading} />
    </>
  );
}
